import cn from "classnames"
import { AnimatePresence, motion } from "framer-motion"
import React, { useContext } from "react"

import { buildings } from "../../helpers/constants"
import AppContext from "../../hooks/AppConext"

const MenuButton = ({ name = "historical" }) => {
  const {
    hovered,
    setSelected,
    selected,
    menuHovered,
    setMenuHovered,
    isMobile,
  } = useContext(AppContext)

  const _hovered = hovered || menuHovered

  const title = buildings[name].name

  const handleClick = (e) => {
    e.preventDefault()
    setSelected(selected !== name ? name : null)
  }

  return (
    <button
      className={cn({
        hovered: _hovered === name,
        selected: selected === name,
      })}
      onClick={handleClick}
      onPointerEnter={() => {
        !isMobile && setMenuHovered(name)
      }}
      onPointerLeave={() => {
        !isMobile && setMenuHovered(null)
      }}
    >
      {title}
    </button>
  )
}

export const AnimatedMenu = () => {
  return (
    <AnimatePresence>
      <motion.menu
        className="menu"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
      >
        <h1>Новый музей</h1>
        <nav className="menu__nav">
          <MenuButton name="historical" />
          <MenuButton name="modern" />
          <MenuButton name="dome" />
        </nav>
      </motion.menu>
    </AnimatePresence>
  )
}
